export class FilesFilter {
  mimetype?: string;
  createdAtFrom?: Date;
  createdAtTo?: Date;

  uploadedById?: number;
  usage?: number;
  isPrivate?: boolean;
}
